<template>
  <v-app style="background: #f2f3f8">
    <v-theme-provider>
      <v-container v-if="loadingClient && !loaded">
        <div class="d-flex flex-column gap-2">
          <v-skeleton-loader height="100" type="image" />
          <v-skeleton-loader height="200" type="image" />
          <v-skeleton-loader height="150" type="image" />
        </div>
      </v-container>
      <v-container v-else-if="!error">
        <div class="d-flex flex-column gap-4">
          <client-account
            :data="data"
            :loading="loadingClient"
            @refresh="getClient"
          />

          <template v-if="loaded">
            <client-tickets :data="data" :loading="loadingClient" />
            <client-tokens :data="data" :loading="loadingClient" />
          </template>
        </div>
      </v-container>
      <v-container v-else>
        <v-alert type="error">{{ error }}</v-alert>
      </v-container>
    </v-theme-provider>
    <RenewToken />
  </v-app>
</template>

<script>
import SUPPORT from "../../services/support";
import PhoneParser from "../../utils/phoneIdentify";
import RenewToken from "../../components/global/RenewToken.vue";

import ClientAccount from "../../components/support/ClientAccount.vue";
import ClientTickets from "../../components/support/ClientTickets.vue";
import ClientTokens from "../../components/support/ClientTokens.vue";

export default {
  components: { ClientAccount, RenewToken, ClientTickets, ClientTokens },
  data() {
    return {
      contact: null,
      data: {},
      loadingClient: false,
      error: null,
      loaded: false,
    };
  },
  methods: {
    async getClient() {
      try {
        const { contact } = this.data;
        this.loadingClient = true;

        const pp = new PhoneParser(contact.phone_number);
        const identify = {
          ddi: pp.getDdi(),
          phone: pp.getPhone(),
        };
        const { user } = await SUPPORT.getClient(identify);

        this.data = {
          ...this.data,
          identify,
          user: {
            ...this.data.user,
            ...(user || {}),
          },
        };
        this.loaded = true;
      } catch (e) {
        this.error = e.message || "Erro ao carregar cliente";
      } finally {
        this.loadingClient = false;
      }
    },
    processMessage(message) {
      if (message.event === "appContext") {
        this.data = message.data;
        this.getClient();
        return;
      }
    },
    receiveMessage(event) {
      if (event.type === "message") {
        if (typeof event.data === "string") {
          try {
            const data = JSON.parse(event.data);
            this.processMessage(data);
          } catch (e) {
            this.processMessage(event.data);
          }
        } else this.processMessage(event.data);
      }
    },
  },
  mounted() {
    window.addEventListener("message", this.receiveMessage);
    window.parent.postMessage("chatwoot-dashboard-app:fetch-info", "*");
  },
};
</script>

<style>
</style>